module.exports = __webpack_public_path__ + "img/PerfumadasPreto.19a9397f.png";